const createAttributes = (divider: string) => ({
    table: {
        style: `border:1px solid ${divider}; border-collapse:collapse;width: 100%;`,
    },
    tr: { style: `border: 1px solid ${divider};` },
    td: { style: `border: 1px solid ${divider}; padding: 0.4em` },
});

export { createAttributes };
